module.exports = __webpack_public_path__ + "img/05.ab6cd7e5.gif";